var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSuccessIconDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 10V20M85 16.7L80 25.36M103.3 35L94.64 40M110 60H100M103.3 85L94.64 80M85 103.3L80 94.64M60 110V100M35 103.3L40 94.64M16.7 85L25.36 80M10 60H20M16.7 35L25.36 40M35 16.7L40 25.36",
    stroke: "#2C303B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43V77M60 77L72 65M60 77L48 65",
    stroke: "#2C303B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSuccessIconDark);
export default __webpack_public_path__ + "static/media/download-success-icon-dark.d0fe2841fe73e4dc59ac6724e333c560.svg";
export { ForwardRef as ReactComponent };